// /* LOCAL TEST */
export const GOOGLE_OAUTH_LOCAL = "9373151167-fnn94osrgct8ceaq4hgittbubhhcehh2.apps.googleusercontent.com";
// export const FACEBOOK_APP_ID = "931896705392347";

/* KHÁCH HÀNG */
export const GOOGLE_OAUTH_CLIENT = "267352745433-ririq5p9l2atqkhrpsmghqmaqb3d5c5j.apps.googleusercontent.com";
// export const FACEBOOK_APP_ID = "1637997533683521";
